"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onAccountDisconnect = exports.onAccountNotAvailable = exports.onAccountChange = exports.onAccountAvailable = void 0;
var index_1 = require("./index");
var bootstrap_1 = require("../bootstrap");
function onAccountAvailable(callback) {
    if (bootstrap_1.isAccountAvailable()) {
        callback();
    }
    else {
        index_1.subscribeEvent('account-available', callback);
    }
}
exports.onAccountAvailable = onAccountAvailable;
function onAccountChange(callback) {
    index_1.subscribeEvent('account-change', callback);
}
exports.onAccountChange = onAccountChange;
function onAccountNotAvailable(callback) {
    index_1.subscribeEvent('account-not-available', callback);
}
exports.onAccountNotAvailable = onAccountNotAvailable;
function onAccountDisconnect(callback) {
    index_1.subscribeEvent('shutdown', callback);
}
exports.onAccountDisconnect = onAccountDisconnect;
//# sourceMappingURL=accounts.js.map